
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductModel } from './Entities.GormCrm.Product';
import { QuestionModel } from './Entities.GormCrm.Question';
import { Model, ModelProperty } from 'models/Model';


export class QuestionnaireQuestionProductModel extends Model<QuestionnaireQuestionProductModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'productId', type: 'string' },
		{ name: 'questionId', type: 'string' },
		{ name: 'required', type: 'boolean' },
		{ name: 'sortOrder', type: 'number' },
		{ name: 'product', type: 'ProductModel', isHidden: true, isObject: true, new: () => { return new ProductModel }, properties: () => { return ProductModel.classProperties } },
		{ name: 'question', type: 'QuestionModel', isHidden: true, isObject: true, new: () => { return new QuestionModel }, properties: () => { return QuestionModel.classProperties } }
	];
	[key: string]: any;
	
	public productId?: string;
	public questionId?: string;
	public required: boolean;
	public sortOrder: number;
	public product?: ProductModel;
	public question?: QuestionModel;
    
	constructor(){
		super();
		this.productId = undefined;
		this.questionId = undefined;
		this.required = false;
		this.sortOrder = 0;
		this.product = undefined;
		this.question = undefined;
		
	}
	getProperties(){
		return QuestionnaireQuestionProductModel.classProperties;
	}
}

